// extracted by mini-css-extract-plugin
export default {"sbtH2":"SbtH2_sbtH2__Zytyk"};